import 'babel-polyfill';
import 'angular-animate';
import 'angular-min-max-validation';
import app from './app';

import './services/latest-backend-response.service';
import './services/latest-backend-response.interceptor';
import './services/addFormService';
import './services/bs-center.service';
import './services/navigation.service/service';
import './services/regions';
import './services/remote-validation';
import './services/simple-form.service';
import './services/segment-fields-limit.service';
import './services/country-codes';
import './services/jk.service';
import './services/popup.service';
import './services/price-estimator.service';
import './services/price-limit.service';
import './services/ad-listener.service';
import './services/pub-avail.service';
import './services/bti.service';
import './services/retry.interceptor';
import './services/retry.service';
import './services/add-form-layout.service';
import './services/http-response-error.service';
import './services/hidden-base.service';
import './services/expired-cookie.service';
import './services/header-promo.service';
import './services/auth.service';
import './services/rent-helper.service';
import './services/root-scope-watcher.service';
import './services/servicePackages.service';
import './services/publishTermsService';
import './services/publishOfferService';

import '../blocks/segments/new-building-form/new-building-form.directive';
import '../blocks/segments/about-building/about-building.directive';
import '../blocks/segments/address/address.directive';
import '../blocks/segments/address/address.service';
import '../blocks/segments/address/geo-selector.service';
import '../blocks/segments/ad-submit-buttons/ad-submit-buttons.directive';
import '../blocks/segments/ad-submit-jk/ad-submit-jk.directive';
import '../blocks/button-clear/button-clear.directive';
import '../blocks/segment-banner/segment-banner.directive';
import '../blocks/estimated-price/estimated-price.directive';
import '../blocks/segments/pub-avail/pub-avail.directive';
import '../blocks/segments/homeowner/homeowner.directive';
import '../blocks/segments/price-estimator-banner/price-estimator-banner.component';
import '../blocks/validation-error/validation-error.directive';

import './directives/digits-only.directive.js';
import './directives/press-enter-event.directive';
import './directives/form-element-untouch.directive';
import './directives/validate-time.directive.js';
import './directives/click-outside.directive';
import './directives/custom-on-change.directive';
import './directives/iframe-onload.directive';
import './directives/cadastral-number.directive.js';
import './directives/observe-element.directive';
import './directives/element-in-viewport.directive';

import '../blocks/segments/contact-info/contact-info.directive';
import '../blocks/segments/phone-verify/phone-verify.directive';
import '../blocks/segments/description-and-photos/description-and-photos.directive';
import '../blocks/segments/description-and-photos/description-and-photos.service';
import '../blocks/segments/cadastral-number-segment/cadastral-number-segment.directive';
import '../blocks/segments/video/video.component';
import '../blocks/phone-input/phone-input.directive';
import '../blocks/phone-verify-form/phone-verify-form.directive';
import '../blocks/price-limit/price-limit';
import '../blocks/radio-wrapper/radio-wrapper';
import '../blocks/price-alert/price-alert';
import '../blocks/select/select.directive';
import '../blocks/retry-notice/retry-notice';
import '../blocks/object-preview/object-preview';
import '../blocks/bs-center-preview/bs-center-preview';
import '../blocks/coworking-preview/coworking-preview';
import '../blocks/jk-preview-typeahead/jk-preview-typeahead';
import '../blocks/offer-preview/offer-preview.directive';
import '../blocks/publish-terms-vc-only/publish-terms-vc-only.directive';
import './segment-inputs-config/about-object/_helpers/rooms-for-count/rooms-for-count';
import './segment-inputs-config/price-and-deal-terms/_helpers/price-currency-select/price-currency-select';
import './segment-inputs-config/price-and-deal-terms/_helpers/price-currency-text/price-currency-text';
import './segment-inputs-config/_helpers/visual-divider/visual-divider';
import './segment-inputs-config/_helpers/field-type-switcher/field-type-switcher';
import './segment-inputs-config/_helpers/field-type-dropdown/field-type-dropdown';
import './segment-inputs-config/_helpers/specialty/specialty';
import './filters/money';
import './filters/sanitize';
import '../blocks/add-form/active-draft/active-draft.directive';
import '../blocks/ad-assessment/ad-assessment.directive';
import '../blocks/header-promo/header-promo.directive';
import '../blocks/expander/expander.directive';
import '../blocks/hint-block/hint-block.directive';
import '../blocks/user-identification/user-identification.directive';
import '../blocks/tarifScreen/tarifScreen.directive';
import '../blocks/select-identification/select-identification.directive';
import '../blocks/verification-task/verification-task.directive';
import '../styles/app.styl';

/** React components */
/** HINT: Используйте CamelCase в путях компонентов, как в остальных микросервисах */
import '../../../shared/components/UseAnotherVertical';
import '../../../shared/components/AuthWidget';
import '../../../shared/components/HomeownerTooltip';
import '../../../shared/components/DealRentTrapAfterFp';
import '../../../shared/components/PublishTerms';
import '../../../shared/components/coworking/CoworkingPlacementApplication';
import '../../../shared/components/SummaryDesktop';
import '../../../shared/components/CandidateSuccessScreen';
import '../../../shared/components/DealRentDepositHint';

export default app;
